/**
 * Main Javascript entry point
 *
 * all imported modules will be bundled to main.js
 * in this file it is possible to include files with globbing
 */

import './app';
/* eslint-disable import/no-unresolved, import/extensions */
;
import '../components/clients/Clients.jsb.js'; import '../components/gallery/Gallery.jsb.js'; import '../components/header/Header.jsb.js'; import '../components/info/Info.jsb.js'; import '../components/projects/Projects.jsb.js'; import '../components/sample/Sample.jsb.js'; import '../components/select/Select.jsb.js'; import '../components/stage-header/Header.jsb.js'; import '../components/stage-header/StageHeader.jsb.js'; import '../components/stage/Stage.jsb.js'; import '../components/technics/Technics.jsb.js'; import '../components/tiles/Tiles.jsb.js';
/* eslint-enable */
